import React from "react";
import {
  Flex,
  Avatar,
  Box,
  useColorModeValue,
  Heading,
  Text,
  Stack,
  List,
  ListItem,
  Link,
  ListIcon,
  Code,
  Button,
} from "@chakra-ui/react";
import { FaMapPin, FaMusic } from "react-icons/fa";
import { GiGamepadCross } from "react-icons/gi";
import { IoDesktopOutline } from "react-icons/io5";
// import Img from "../assets/ziad.png";
// import resume from "../../Assets/Resume";
// import Typist from "react-typist";
// import ShubhamVerma from "../../Assets/ShubhamVerma.pdf";

function Home() {
  const onButtonClick = () => {
    // using Java Script method to get PDF file
    fetch('ShubhamVerma.pdf').then(response => {
        response.blob().then(blob => {
            // Creating new object of PDF file
            const fileURL = window.URL.createObjectURL(blob);
            // Setting various property values
            let alink = document.createElement('a');
            alink.href = fileURL;
            alink.download = 'ShubhamVerma.pdf';
            alink.click();
        })
    })
}

  return (
    <Flex direction="column" align="center" py={40}  id="home" 
    bgImage={useColorModeValue("https://images.unsplash.com/photo-1518655048521-f130df041f66?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D","https://user-images.githubusercontent.com/6901805/58038897-167f0280-7ae6-11e9-94eb-88e880a25f0f.gif")}
    
    bgRepeat='no-repeat'  bgSize={'cover'}  >
      <Flex direction={["column", "column", "row"]}>
        <Avatar
          size={"2xl"}
          src='https://user-images.githubusercontent.com/94439105/172840833-c9a05c09-5d35-415e-9721-76c617aa4afd.png'
          alt="Shubham"
          loading="eager"
          mb={4}
          display={["block", "block", "none"]}
          alignSelf={"center"}
        />

        <Box p={4} mr={4} w={"full"} maxW="800px">
          <Heading
            mb={6}
            fontSize={{ base: "3xl", md: "4xl", lg: "5xl" }}
            fontWeight="bold"
            color={useColorModeValue("brand.600", "gray.300")}
            lineHeight="shorter"
            textAlign={{ base: "inherit", md: "start" }}
          >
            Hey, I'm{" "}
            <Text
              display={"inline"}
              w="full"
              bgClip="text"
              bgGradient="linear(to-l, blue.300, purple.600)"
              fontWeight="extrabold"
            >
              Shubh
            </Text>
          </Heading>

          <Text
            pr={{ base: 0, md: 16 }}
            mb={4}
            fontSize={{ base: "md", md: "lg" }}
            color={useColorModeValue("brand.600", "gray.400")}
            letterSpacing="wider"
            textAlign={"start"}
            fontFamily={"body"}
          >
           “Learning to write programs stretches your mind, and helps you think better, creates a way of thinking about things that I think is helpful in all domains.” - Bill Gates
           <br/>
            
            <br />
            <Code animation="infinite" fontSize={"xl"} colorScheme='cyan'>
            <a href="/"><img src="https://readme-typing-svg.herokuapp.com?color=000&center=true&lines=1500%2B+Hours+of+Coding+Experience;Data+Structure;Algorithm;MERN;Full+Stack+Web+Developer" alt="typist"></img></a>
              {/* <Typist>I build things for the web</Typist> */}
            </Code>
            
            <br />I code <Code colorScheme="blue"> beautifully</Code>{" "}
            <Code colorScheme="green"> simple</Code> things and I{" "}
            <Code colorScheme="red"> love </Code> what I do
            <br />
            When I'm not coding I'm still on my computer{" "}
            <Code colorScheme={"orange"}>gaming 🎮</Code>
            <br />
            <br />
            In addition to my development work, I am skilled in troubleshooting problems and resolving bugs within an existing system.
            <br />
          </Text>
        </Box>
        <Box
          maxW={"320px"}
          w={"full"}
          bg={useColorModeValue("gray.100", "gray.900")}
          shadow={"lg"}
          rounded={"lg"}
          p={6}
          textAlign={"center"}
          display={["none", "none", "block"]}
        >
          <Avatar size={"2xl"} src='https://user-images.githubusercontent.com/94439105/172840833-c9a05c09-5d35-415e-9721-76c617aa4afd.png' alt="Shubham" loading="eager" mb={4} />

          <Heading fontSize="md" fontWeight={400}>
            Shubham Verma
          </Heading>
          <Text fontSize={"md"} fontWeight={200} color={"gray.500"} mb={4}>
            Full-Stack Web Developer
          </Text>

          <Stack
            align={"flex-start"}
            justify={"flex-start"}
            direction={"column"}
            textAlign={"left"}
            mt={6}
          >
            <Text
              fontSize="sm"
              fontWeight={400}
              color={"gray.500"}
              textTransform="uppercase"
            >
              Currently
            </Text>

            <List spacing={3} w={"full"}>
              <ListItem
                p={1}
                border={"solid 2px transparent"}
                rounded={"md"}
                cursor={"pointer"}
                _hover={{ color: "blue.400" }}
              >
                <Link
                  href="https://www.google.com/maps/place/New+Delhi,+Delhi/@28.6588928,77.266944,10z/data=!4m5!3m4!1s0x390cfd5b347eb62d:0x52c2b7494e204dce!8m2!3d28.6139391!4d77.2090212"
                  target="_blank"
                  _hover={{ textDecoration: "none" }}
                  _focus={{ outline: "none" }}
                >
                  <Flex direction={"row"} align={"center"}>
                    <ListIcon w={4} h={4} as={FaMapPin} color="blue.400" />

                    <Flex direction={"column"} ml={2} fontSize={"md"}>
                      New Delhi
                      <Text
                        fontSize={"xs"}
                        color={useColorModeValue("gray.800", "white")}
                      >
                        India
                      </Text>
                    </Flex>
                  </Flex>
                </Link>
              </ListItem>
              <ListItem
                p={1}
                border={"solid 2px transparent"}
                rounded={"md"}
                cursor={"pointer"}
                _hover={{ color: "blue.400" }}
              >
                <Link
                  href="https://open.spotify.com/album/2nLOHgzXzwFEpl62zAgCEC"
                  target="_blank"
                  _hover={{ textDecoration: "none" }}
                  _focus={{ outline: "none" }}
                >
                  <Flex direction={"row"} align={"center"}>
                    <ListIcon w={4} h={4} as={FaMusic} color="blue.400" />

                    <Flex direction={"column"} ml={2} fontSize={"md"}>
                      Dawn FM
                      <Text
                        fontSize={"xs"}
                        color={useColorModeValue("gray.800", "white")}
                      >
                        The Weeknd
                      </Text>
                    </Flex>
                  </Flex>
                </Link>
              </ListItem>
              <ListItem
                p={1}
                border={"solid 2px transparent"}
                rounded={"md"}
                cursor={"pointer"}
                _hover={{ color: "blue.400" }}
              >
                <Link
                  href="https://www.youtube.com/watch?v=weD2tVLaIEQ"
                  target="_blank"
                  _hover={{ textDecoration: "none" }}
                  _focus={{ outline: "none" }}
                >
                
                  <Flex direction={"row"} align={"center"}>
                    <ListIcon
                      w={4}
                      h={4}
                      as={IoDesktopOutline}
                      color="blue.400"
                    />

                    <Flex direction={"column"} ml={2} fontSize={"md"}>
                    INSANE TRADER
                      <Text
                        fontSize={"xs"}
                        color={useColorModeValue("gray.800", "white")}
                      >
                         Jim Simons
                      </Text>
                    </Flex>
                  </Flex>
                </Link>
              </ListItem>
              <ListItem
                p={1}
                border={"solid 2px transparent"}
                rounded={"md"}
                cursor={"pointer"}
                _hover={{ color: "blue.400" }}
              >
                
                  <Link
                  href="https://store.steampowered.com/app/546560/HalfLife_Alyx/"
                  target="_blank"
                  _hover={{ textDecoration: "none" }}
                  _focus={{ outline: "none" }}
                >
                  <Flex direction={"row"} align={"center"}>
                    <ListIcon w={4} h={4} as={GiGamepadCross} color="blue.400" />

                    <Flex direction={"column"} ml={2} fontSize={"md"}>
                    Half-Life
                      <Text
                        fontSize={"xs"}
                        color={useColorModeValue("gray.800", "white")}
                      >
                        Alyxs
                      </Text>
                    </Flex>
                  </Flex>
                  </Link>
              </ListItem>
            </List>
            <Button
              as={Link}
              href='https://drive.google.com/file/d/1b-PGZK_JrQDcOtYpzlOBR4wixRkGXqZh/view?usp=sharing'
              target="_blank"
              w={"full"}
              mt={8}
              bg={useColorModeValue("gray.300", "gray.700")}
              color={useColorModeValue("gray.800", "white")}
              rounded={"md"}
              _hover={{
                bg: useColorModeValue("gray.200", "gray.800"),
                textDecoration: "none",
              }}
              _focus={{ outline: "none" }}
            >
            View Resume
            </Button>
            <Button
            // download={ShubhamVerma.pdf}
            onClick={onButtonClick}
              as={Link}
              w={"full"}
              mt={8}
              bg={useColorModeValue("gray.300", "gray.700")}
              color={useColorModeValue("gray.800", "white")}
              rounded={"md"}
              _hover={{
                bg: useColorModeValue("gray.200", "gray.800"),
                textDecoration: "none",
              }}
              _focus={{ outline: "none" }}
            >
            Download Resume
            </Button>
          </Stack>
        </Box>
      </Flex>
    </Flex>
  );
}

export default Home;